import { defineAsyncComponent, computed, ref } from 'vue';
import "ant-design-vue/es/menu/style/css";
import _Menu from "ant-design-vue/es/menu";
import "ant-design-vue/es/dropdown/style/css";
import _Dropdown from "ant-design-vue/es/dropdown";
import "ant-design-vue/es/tabs/style/css";
import _Tabs from "ant-design-vue/es/tabs";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-56c7e114"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tabs_box"
};
const _hoisted_2 = {
  class: "tab_title"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "reload"
};
const _hoisted_5 = {
  class: "content"
};
import { useStore } from 'vuex';
export default {
  __name: 'MultiTab',
  setup(__props) {
    const store = useStore();
    const requireContext = require.context("@/views", true, /\.vue$/i, "sync");
    const componentNames = requireContext.keys().map(file => file.replace(/(^.\/)|(\.vue$)/g, ""));
    const componenPath = requireContext.keys().map(file => file.replace(/(^.\/)|(\.vue$)/g, ""));
    let components = {};
    componentNames.forEach((component, i) => {
      components[component] = defineAsyncComponent(() => import("@/views/" + componenPath[i]));
    });
    const selSystem = computed(() => [store.state.curSystem]);
    const activeKey = computed(() => store.state.curSelKey);
    const loading = ref(false);
    const tabs = computed(() => {
      return store.state.tabs;
    });
    const reloadAction = item => {
      loading.value = true;
      item.refresh = true;
      setTimeout(() => {
        item.refresh = false;
        loading.value = false;
      }, 10);
    };
    const changePage = e => {
      console.log(e);
      store.commit('setCurKey', e);
    };
    const closeAction = index => {
      store.commit('removeTab', index);
    };
    const closeOther = (item, index) => {
      store.commit('closeOther', item);
    };
    const closeLeft = (item, index) => {
      store.commit('closeLeft', index);
    };
    const closeRight = (item, index) => {
      store.commit('closeRight', index);
    };
    return (_ctx, _cache) => {
      const _component_ReloadOutlined = _resolveComponent("ReloadOutlined");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_CloseOutlined = _resolveComponent("CloseOutlined");
      const _component_a_space = _resolveComponent("a-space");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(_Tabs), {
        activeKey: _unref(activeKey),
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => _isRef(activeKey) ? activeKey.value = $event : null),
        class: "tabs",
        animated: false
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (item, index) => {
          return _openBlock(), _createBlock(_unref(_Tabs).TabPane, {
            key: item.id,
            forceRender: true
          }, {
            tab: _withCtx(() => [_createVNode(_unref(_Dropdown), {
              trigger: ['contextmenu']
            }, {
              overlay: _withCtx(() => [_createVNode(_unref(_Menu), null, {
                default: _withCtx(() => [_createVNode(_unref(_Menu).Item, {
                  onClick: $event => closeOther(item, index)
                }, {
                  default: _withCtx(() => [_createTextVNode("关闭其他 ")]),
                  _: 2
                }, 1032, ["onClick"]), _createVNode(_unref(_Menu).Item, {
                  onClick: $event => closeLeft(item, index)
                }, {
                  default: _withCtx(() => [_createTextVNode("关闭左侧")]),
                  _: 2
                }, 1032, ["onClick"]), _createVNode(_unref(_Menu).Item, {
                  onClick: $event => closeRight(item, index)
                }, {
                  default: _withCtx(() => [_createTextVNode("关闭右侧 ")]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)]),
              default: _withCtx(() => {
                var _item$meta;
                return [_createElementVNode("div", _hoisted_2, [_createElementVNode("label", {
                  onClick: $event => changePage(item.id)
                }, _toDisplayString(item === null || item === void 0 ? void 0 : (_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : _item$meta.title), 9, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_space, null, {
                  default: _withCtx(() => [_createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [_createTextVNode("刷新")]),
                    default: _withCtx(() => [_createVNode(_component_ReloadOutlined, {
                      spin: loading.value,
                      onClick: $event => reloadAction(item)
                    }, null, 8, ["spin", "onClick"])]),
                    _: 2
                  }, 1024), _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [_createTextVNode("关闭")]),
                    default: _withCtx(() => [_createVNode(_component_CloseOutlined, {
                      onClick: $event => closeAction(index)
                    }, null, 8, ["onClick"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024)])])];
              }),
              _: 2
            }, 1024)]),
            closeIcon: _withCtx(() => [_createVNode(_component_a_tooltip, null, {
              title: _withCtx(() => [_createTextVNode("关闭")]),
              default: _withCtx(() => [_createVNode(_component_CloseOutlined, {
                style: {
                  "margin-left": "10px"
                },
                onClick: $event => closeAction(index)
              }, null, 8, ["onClick"])]),
              _: 2
            }, 1024)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [!(item !== null && item !== void 0 && item.refresh) ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(components)[item.component]), {
              key: 0,
              Meta: {
                AppName: item.meta.title
              }
            }, null, 8, ["Meta"])) : _createCommentVNode("", true)])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["activeKey"])]);
    };
  }
};